// En que se baso para contestar eso (R3, CA3).
//
// Es lo que compensa haber dejado de preguntar. Desde el 2026-09-17 el sistema
// clasifica los documentos por su cuenta y los aplica sin que nadie apruebe
// nada; lo que se le debe a cambio a quien ya no decide es **poder ver por que**
// salio ese documento y no otro. Sin esto, el plan que quita el buzon deja al
// usuario delante de un agente que ordena en silencio.
//
// **Solo los documentos que buscó para esta respuesta.** Del 2026-09-19 al
// 2026-09-27 enseñaba también las memorias del espacio de trabajo, pero esas le
// llegan en todos los turnos: salían siempre las mismas, preguntaras lo que
// preguntaras, y decían «me basé en esto» de cosas que no tenían nada que ver.
// Cuando usa una norma tuya lo dice en la respuesta, que es donde sirve.
//
// Va debajo de la respuesta, al lado de las herramientas y del coste, porque es
// la misma clase de dato -de donde sale lo que acaba de decir- y porque es
// donde ya se mira. Un sitio aparte obligaria a saber que existe.
//
// **La frase del porqué no se traduce aquí.** La escribe el servidor, donde
// vive la regla que la produce.

import { useTranslation } from 'react-i18next'
import { FileText } from 'lucide-react'
import { cn } from '@/lib/utils'
import type { EnQueSeBaso as Base } from '@/services/brainApi'

export function EnQueSeBaso({ base }: { base: Base }) {
  const { t } = useTranslation()
  if (base.documentos.length === 0) return null

  return (
    <div className="mt-2 border-t border-border pt-2">
      <p className="mb-1.5 text-xs text-muted-foreground">{t('brain.en_que_me_base')}</p>
      <ul className="space-y-1">
        {base.documentos.map((documento, i) => (
          <li key={`${documento}-${i}`} className="flex items-center gap-1.5 text-xs">
            <FileText className="h-3 w-3 shrink-0 text-muted-foreground" />
            {/* El primero es el que contesto. Los demas viajaron con el, y
                enseñarlos todos iguales haria creer que la respuesta sale de
                los cuatro por igual. */}
            <span className={cn('truncate', i === 0 ? 'font-medium' : 'text-muted-foreground')}>
              {documento}
            </span>
          </li>
        ))}
      </ul>
      {base.porQue && <p className="mt-1.5 text-xs text-muted-foreground">{base.porQue}</p>}
    </div>
  )
}
